import 'bootstrap';
import React from 'react';
import Filters from '../Filters/section3';
import BarChart from '../Barchart/vertical';
// import BarChartOthers from '../Barchart';
import getDoc from "../../qdoc";

export default class Section3 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      yearMeasure: "num(Sum([Total Amount]),'$#,##0.00')",
    }

    this.changeYearMeasure = this.changeYearMeasure.bind(this);
  }

  changeYearMeasure(event) {
    this.setState({ yearMeasure: event.target.value });
  }

  clearSelections() {
    getDoc.then(doc => {
      doc.clearAll(false, 'State1');
    });
  }

  render() {
    return (
        <div className="container" id="S3">
        <section className="overtime mb-5"> 
           
          <div className="row flex-wrap justify-content-around align-items-center">
            <div className="col">
              <div className="d-flex align-items-end" style={{borderBottom:'2px solid #ECEEEF'}}>
                <div>
                  Donation <span className="textgreen">Evolution</span>
                </div>
                <div className="ml-auto">
                <label className="custom-control custom-radio">
                  <input id="radio3" name="radio" type="radio" className="custom-control-input" value="num(Sum([Total Amount]),'$#,##0.00')" checked={this.state.yearMeasure === "num(Sum([Total Amount]),'$#,##0.00')"} onChange={this.changeYearMeasure} /><span className="custom-control-indicator"></span>
                  <span className="custom-control-description">Amount</span>
                </label>
                <label className="custom-control custom-radio">
                <input id="radio4" name="radio" type="radio" className="custom-control-input" value="num(Sum(DonationCount),'#,##0')" checked={this.state.yearMeasure === "num(Sum(DonationCount),'#,##0')"} onChange={this.changeYearMeasure} />
                  <span className="custom-control-indicator"></span>
                  <span className="custom-control-description">Number of donations</span>
                </label>
              </div>
              </div>

              
              <div className="chartcontainer" style={{overflowX: 'auto', overflowY: 'hidden', textAlign: 'center'}}>
                <BarChart qStateName="State1" dimension="[Year]" measure={this.state.yearMeasure} sortorder={[0,1]} topMargin="100" bottomMargin="30"/>
              </div>
            </div>
          </div>
          <Filters/>
        </section>

        </div>
    );
  }
}



        


// WEBPACK FOOTER //
// ./components/Sections/section3.js